<template>
  <print v-if="isPrint" :form="form" :board="board" :employeeList="employeeList" :etcEmployeeList="form.etcEmployeeList" />
  <div v-else>
    <!-- 기본정보 -->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" />

    <!-- 교육내용 -->
    <div>
      <vs-row class="mt-6 mb-4">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i>{{ $t("교육내용") }}</h5>
        </vs-col>
      </vs-row>

      <div class="writeGridContainer">
        <div>
          <div>{{ $t("교육구분") }}</div>
          <custom-option-selector :readonly="board.readonly" :value="form.education_type" @change="changeTarget1" :options="diff" />
        </div>
        <div v-if="!!form.education_type && 1 < diff[form.education_type.index].child.length" class="writeGridLineItem">
          <div>{{ $t("대상(작업명)") }}</div>
          <custom-option-selector
            :readonly="board.readonly"
            v-model="form.target_work"
            :options="diff[form.education_type.index].child"
            :placeholder="$t('1. 고압실 내 작업(잠함공법이나 그 밖의 압기공법으로 대기압을 넘는 기압인 작업실 또는 수갱 내부에서 하는 작업만 해당한다)')"
            @input="changeTarget2"
          />
        </div>
        <div>
          <div>{{ $t("교육명") }}</div>
          <ml-input v-model="form.education_name" :readonly="board.readonly" :placeholder="$t('입력필드')" />
        </div>
        <div>
          <div>{{ $t("교육일") }}</div>
          <date-selector v-model="form.education_date" :readonly="board.readonly" />
        </div>
        <div>
          <div>{{ $t("교육시간") }}</div>
          <div class="time">
            <time-selector v-model="form.education_start_time" :readonly="board.readonly" />
            <p>~</p>
            <time-selector v-model="form.education_end_time" :readonly="board.readonly" />
          </div>
        </div>
        <div>
          <div>{{ $t("교육장소") }}</div>
          <ml-input v-model="form.education_location" :readonly="board.readonly" :placeholder="$t('입력필드')" />
        </div>
      </div>
      <div class="writeGridContainer">
        <div class="writeGridLineItem">
          <div>{{ $t("교육내용에 반영한 재해형태(필수)") }}</div>
          <disaster-class-selector :multiple="true" :readonly="board.readonly" :addData="['직접입력']" :placeholder="$t('입력필드')" v-model="form.reflected_disaster_type" />
        </div>
        <div v-show="form.reflected_disaster_type.includes('직접입력')">
          <div>{{ $t("직접입력") }}</div>
          <ml-input v-model="form.disaster_type_direct_input" :readonly="board.readonly" :placeholder="$t('입력필드')" />
        </div>
      </div>
      <div class="writeGridContainer">
        <div>
          <div>{{ $t("교육 실시자 성명") }}</div>
          <ml-input v-model="form.instructor_full_name" :readonly="board.readonly" :placeholder="$t('입력필드')" />
        </div>
        <div>
          <div>{{ $t("교육 실시자 소속") }}</div>
          <ml-input v-model="form.instructor_affiliation" :readonly="board.readonly" :placeholder="$t('입력필드')" />
        </div>
        <div>
          <div>{{ $t("교육 실시자 직책") }}</div>
          <ml-input v-model="form.instructor_position" :readonly="board.readonly" :placeholder="$t('입력필드')" />
        </div>
        <div>
          <div>{{ $t("교육 대상") }}</div>
          <ml-input v-model="form.education_target" :readonly="board.readonly" :placeholder="$t('입력필드')" />
        </div>
        <div>
          <div>{{ $t("교육 실시 인원") }}</div>
          <comma-input v-model="form.participants_attended" type="number" :readonly="board.readonly" :placeholder="$t('입력필드')" />
          <p>{{ $t("명") }}</p>
        </div>
        <div>
          <div>{{ $t("교육 미실시 인원") }}</div>
          <comma-input v-model="form.participants_not_attended" type="number" :readonly="board.readonly" />
          <p>{{ $t("명") }}</p>
        </div>
        <div class="writeGridLineItem">
          <div>{{ $t("교육내용") }}</div>
          <ml-textarea rows="5" v-model="form.education_content" :readonly="board.readonly" />
        </div>
        <div class="writeGridLineItem">
          <div>{{ $t("근로자 의견") }}</div>
          <ml-textarea rows="5" v-model="form.worker_opinion" :readonly="board.readonly" />
        </div>
      </div>
    </div>

    <!-- 참석자 명단 -->
    <table-custom
      :controls="true"
      :multiple="true"
      :board="board"
      :is-print="isPrint"
      :title="$t('참석자 명단')"
      :tableData="[
        { id: 'com_name', title: $t('소속명'), type: 'fixed-text', placeholder: '' },
        { id: 'employment_type', title: $t('직종'), type: 'fixed-text', placeholder: '' },
        { id: 'full_name', title: $t('이름'), type: 'fixed-text', placeholder: '' },
        { id: 'sign', title: $t('서명'), type: 'sign', placeholder: '' },
        { id: 'note', title: $t('비고'), type: 'text', placeholder: '' },
      ]"
      :mobile="['com_name', 'full_name']"
      v-model="employeeList"
      class="mt-4"
      :button-add-name="$t('참석자 등록')"
      :custom-add-handler="true"
      :custom-remove-handler="true"
      @add-row="onClickAddEmployee"
      @remove-row="onClickRemoveEmployee"
    />

    <!-- 시스템 미등록 참석자 명단 -->
    <table-custom
      :controls="true"
      :multiple="true"
      :board="board"
      :is-print="isPrint"
      :title="$t('시스템 미등록 참석자 명단')"
      :tableData="[
        { id: 'com_name', title: $t('소속명'), type: 'text', placeholder: '' },
        { id: 'employment_type', title: $t('직종'), type: 'text', placeholder: '' },
        { id: 'full_name', title: $t('이름'), type: 'text', placeholder: '' },
        { id: 'sign', title: $t('서명'), type: 'sign', placeholder: '' },
        { id: 'note', title: $t('비고'), type: 'text', placeholder: '' },
      ]"
      :mobile="['com_name', 'full_name']"
      v-model="form.etcEmployeeList"
      class="mt-4"
      :button-add-name="$t('참석자 추가')"
    />

    <!-- 확인자 -->
    <!-- 결재란 -->
    <div class="mt-8">
      <div>
        <h5><i class="dot"></i>{{ $t("결재란") }}</h5>
      </div>
      <name-with-signature-row :label-name="$t('작성자')" :name.sync="form.sign1.name" :signature.sync="form.sign1.sign" />
      <name-with-signature-row :label-name="$t('검토자')" :name.sync="form.sign2.name" :signature.sync="form.sign2.sign" />
      <name-with-signature-row :label-name="$t('회람자')" :name.sync="form.sign3.name" :signature.sync="form.sign3.sign" />
      <name-with-signature-row :label-name="$t('승인자')" :name.sync="form.sign4.name" :signature.sync="form.sign4.sign" />
    </div>

    <!-- 사진대지 -->
    <photo-upload-grid-module :row-count="2" :grid-count="2" v-model="form.photoList" :is-print="isPrint" :readonly="board.readonly" :section-title="$t('교육 사진')" :placeholder="$t('신축현장 점검')" />

    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>

    <popup-search-employee-checkbox v-model="showPopup" :initSelectedEmployees="JSON.parse(JSON.stringify(employeeList))" @handleClickSelect="handleEmployeeSelect" />
  </div>
</template>

<script>
import DateSelector from "@/components/selector/DateSelector";
import TimeSelector from "@/components/selector/TimeSelector";
import CustomOptionSelector from "@/components/selector/CustomOptionSelectorObject";
import DisasterClassSelector from "@/components/selector/DisasterClassSelector";
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import Print from "./Print.vue";

import KPagination from "@/components/kPagination/kPagination";
import SearchNavStartEnd from "@/components/nav/SearchNavStartEnd.vue";
import SearchNavItemKeyword from "@/components/nav/SearchNavItemKeyword";
import SearchNavItemSelect from "@/components/nav/SearchNavItemSelect";
import { valueDisasters } from "@/util/DisasterDataUtil";
import TableCustom from "@/components/TableCustom.vue";
import getDiffData from "./DiffData";
import SignField from "@/components/SignField.vue";
import PopupSearchEmployeeCheckbox from "@/popup/PopupSearchEmployeeCheckbox.vue";
import moment from "moment";
import NameWithSignatureRow from "@/components/NameWithSignatureRow.vue";

export default {
  components: {
    NameWithSignatureRow,
    PopupSearchEmployeeCheckbox,
    Print,
    PhotoUploadGridModule,
    FieldSelectModule,
    CustomOptionSelector,
    FileUploadModule,
    DateSelector,
    DisasterClassSelector,
    TimeSelector,
    KPagination,
    SearchNavStartEnd,
    SearchNavItemKeyword,
    SearchNavItemSelect,
    TableCustom,
    SignField,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  data() {
    return {
      // =============== 이전 문서 불러오기 ===============
      isMounted: false,
      customButton: null,
      showPopup: false,
      disasterTypes: [{ text: this.$t("전체선택"), value: "" }, ...valueDisasters()],
      searchTypes: [
        { value: "stdInfo.field_name", text: this.$t("현장명") },
        { value: "inputD_1", text: this.$t("재해일시") },
        { value: "inputD_3", text: this.$t("발생형태") },
        { value: "stdInfo.department", text: this.$t("소속명") },
        { value: "stdInfo.com_name", text: this.$t("부서명") },
        { value: "stdInfo.writer_name", text: this.$t("작성자") },
      ],
      // 페이징
      page: {
        current: 1,
        lastPage: 1,
        perPage: 10,
      },
      // 검색
      search: {
        date: "", // 작성일
        disasterType: "", // 발생형태
        searchType: "", // 검색조건
        searchKeyword: "", // 키워드
      },

      // 종사자 정보
      employeeList: [],
      loadEmployee: false,

      // =============== FORM ===============
      form: {
        stdInfo: {},

        education_type: null,
        target_work: null,

        education_name: "",
        education_date: "",
        education_start_time: "",
        education_end_time: "",
        education_location: "",
        reflected_disaster_type: [],
        instructor_full_name: "",
        instructor_affiliation: "",
        instructor_position: "",
        education_target: "",
        participants_attended: "",
        participants_not_attended: "",
        education_content: "",
        worker_opinion: "",
        disaster_type_direct_input: "",
        // 교육 시간
        educationHours: 0,

        selectedEmployees: [],
        etcEmployeeList: [],
        photoList: [],
        fileList: [],
        signatureList: [],
        sign1: {
          name: "",
          sign: "",
        },
        sign2: {
          name: "",
          sign: "",
        },
        sign3: {
          name: "",
          sign: "",
        },
        sign4: {
          name: "",
          sign: "",
        },
        disasters: "",
      },
    };
  },
  computed: {
    // computed
    projectId() {
      return parseInt(this.$route.params.proj_id);
    },
    // diff 데이터를 computed로 변경하여 언어 변경 시 자동으로 업데이트
    diff() {
      // i18n.locale을 참조하여 언어 변경 시 자동으로 재계산되도록 함
      // eslint-disable-next-line no-unused-vars
      const locale = this.$i18n.locale;
      // getDiffData()를 호출하여 현재 언어로 번역된 데이터를 반환
      return JSON.parse(JSON.stringify(getDiffData()));
    },
  },
  watch: {
    value: {
      important: true,
      deep: true,
      handler(value) {
        if (value) {
          const keys = Object.keys(value);
          for (const key of keys) {
            if (value[key]) {
              this.form[key] = value[key];
            }
          }
        }
      },
    },
    /**
     * 종사자 목록이 갱신되면, form 내에는 ID 값만 추출해서 보관한다.
     * 종사자 정보 중에는 암호화되어 있는 데이터가 있기 때문에, 모든 정보를 보관하면 보안상 문제가 발생할 수 있다.
     * {id: 1, note: '비고'} 형식으로 변환한다
     */
    employeeList: {
      immediate: true,
      deep: true,
      handler(value) {
        this.form.selectedEmployees = value.map((item) => {
          return { id: item.id, note: item.note, sign: item.sign };
        });
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.summary = {
          안전보건교육_현장명: [],
          안전보건교육_재해형태: [],
          안전보건교육_교육구분: [],
          안전보건교육_현장별교육구분: [],
          안전보건교육_현장별재해형태: [],
        };

        value.summary["안전보건교육_현장명"].push({
          [this.form.stdInfo.field_name]: 1,
        });

        if (this.form.education_type) {
          value.summary["안전보건교육_교육구분"].push({
            [this.form.education_type.value]: 1,
          });

          value.summary["안전보건교육_현장별교육구분"].push({
            [`${this.form.stdInfo.field_name}_${this.form.education_type.value}`]: 1,
          });
        }

        if (this.form.reflected_disaster_type && this.form.reflected_disaster_type.length > 0) {
          for (const data of this.form.reflected_disaster_type) {
            value.summary["안전보건교육_재해형태"].push({
              [data]: 1,
            });

            value.summary["안전보건교육_현장별재해형태"].push({
              [`${this.form.stdInfo.field_name}_${data}`]: 1,
            });
          }
        }

        // 문서에는 종사자 ID 값만 보관되어 있다.
        // ID 값에 해당하는 종사자 목록을 불러오도록 한다
        this.initEmployeeList();

        // 교육 시간을 갱신한다
        this.updateEducationHours();

        this.$emit("input", value);
      },
    },
  },
  created() {
    const keys = Object.keys(this.form);
    for (const key of keys) {
      if (this.value[key]) {
        this.form[key] = this.value[key];
      }
    }
  },
  methods: {
    translationMap() {
      const prefix = "안전보건교육.안전보건교육";
      const translateData = {
        [`${prefix}.기본정보.회사명`]: this.form.stdInfo.field_name,
        [`${prefix}.기본정보.작성자이름`]: this.form.stdInfo.writer_name,
        [`${prefix}.기본정보.작성일`]: this.form.stdInfo.date,

        // 교육구분은 i18n으로 처리되므로 번역에서 제외
        [`${prefix}.교육내용.교육명`]: this.form.education_name,
        [`${prefix}.교육내용.교육일`]: this.form.education_date,
        [`${prefix}.교육내용.교육시간.시작시간`]: this.form.education_start_time,
        [`${prefix}.교육내용.교육시간.종료시간`]: this.form.education_end_time,
        [`${prefix}.교육내용.교육장소`]: this.form.education_location,
        [`${prefix}.교육내용.교육내용에 반영한 재해형태`]: this.form.reflected_disaster_type,
        [`${prefix}.교육내용.교육 실시자 성명`]: this.form.instructor_full_name,
        [`${prefix}.교육내용.교육 실시자 소속`]: this.form.instructor_affiliation,
        [`${prefix}.교육내용.교육 실시자 직책`]: this.form.instructor_position,
        [`${prefix}.교육내용.교육 대상`]: this.form.education_target,
        [`${prefix}.교육내용.교육 실시 인원`]: this.form.participants_attended,
        [`${prefix}.교육내용.교육 미실시 인원`]: this.form.participants_not_attended,
        [`${prefix}.교육내용.교육내용`]: this.form.education_content,
        [`${prefix}.교육내용.근로자 의견`]: this.form.worker_opinion,

        [`${prefix}.참석자 명단`]: this.employeeList.map((item) => {
          return {
            소속명: item.com_name,
            직종: item.employment_type,
            이름: item.full_name,
            비고: item.note,
          };
        }),

        [`${prefix}.시스템 미등록 참석자 명단`]: this.form.etcEmployeeList.map((item) => {
          return {
            소속명: item.com_name,
            직종: item.employment_type,
            이름: item.full_name,
            비고: item.note,
          };
        }),

        [`${prefix}.확인자.안전관리자`]: this.form.sign1.name,
        [`${prefix}.확인자.관리책임자`]: this.form.sign2.name,
        [`${prefix}.교육사진`]: this.form.photoList.map((item) => {
          return {
            input: item.input,
          };
        }),
      };

      return translateData;
    },
    translate(translate) {
      const prefix = "안전보건교육.안전보건교육";

      this.form.stdInfo.field_name = translate[`${prefix}.기본정보.회사명`];
      this.form.stdInfo.writer_name = translate[`${prefix}.기본정보.작성자이름`];
      this.form.stdInfo.date = translate[`${prefix}.기본정보.작성일`];

      // 교육구분은 i18n으로 처리되므로 번역에서 제외

      this.form.education_name = translate[`${prefix}.교육내용.교육명`];
      this.form.education_date = translate[`${prefix}.교육내용.교육일`];
      this.form.education_start_time = translate[`${prefix}.교육내용.교육시간.시작시간`];
      this.form.education_end_time = translate[`${prefix}.교육내용.교육시간.종료시간`];
      this.form.education_location = translate[`${prefix}.교육내용.교육장소`];
      this.form.reflected_disaster_type = translate[`${prefix}.교육내용.교육내용에 반영한 재해형태`];
      this.form.instructor_full_name = translate[`${prefix}.교육내용.교육 실시자 성명`];
      this.form.instructor_affiliation = translate[`${prefix}.교육내용.교육 실시자 소속`];
      this.form.instructor_position = translate[`${prefix}.교육내용.교육 실시자 직책`];
      this.form.education_target = translate[`${prefix}.교육내용.교육 대상`];
      this.form.participants_attended = translate[`${prefix}.교육내용.교육 실시 인원`];
      this.form.participants_not_attended = translate[`${prefix}.교육내용.교육 미실시 인원`];
      this.form.education_content = translate[`${prefix}.교육내용.교육내용`];
      this.form.worker_opinion = translate[`${prefix}.교육내용.근로자 의견`];

      // 참석자 명단 처리
      const employeeList = translate[`${prefix}.참석자 명단`];
      if (employeeList && employeeList.length > 0) {
        const _employeeList = [];
        for (let i = 0; i < employeeList.length; i++) {
          const originalItem = this.employeeList[i] || {};
          _employeeList.push({
            ...originalItem,
            com_name: employeeList[i]["소속명"],
            employment_type: employeeList[i]["직종"],
            full_name: employeeList[i]["이름"],
            note: employeeList[i]["비고"],
          });
        }
        this.employeeList = _employeeList;
      }

      // 시스템 미등록 참석자 명단 처리
      const etcEmployeeList = translate[`${prefix}.시스템 미등록 참석자 명단`];
      if (etcEmployeeList && etcEmployeeList.length > 0) {
        const _etcEmployeeList = [];
        for (let i = 0; i < etcEmployeeList.length; i++) {
          const originalItem = this.form.etcEmployeeList[i] || {};
          _etcEmployeeList.push({
            ...originalItem,
            com_name: etcEmployeeList[i]["소속명"],
            employment_type: etcEmployeeList[i]["직종"],
            full_name: etcEmployeeList[i]["이름"],
            note: etcEmployeeList[i]["비고"],
          });
        }
        this.$set(this.form, "etcEmployeeList", _etcEmployeeList);
      }

      this.form.sign1.name = translate[`${prefix}.확인자.안전관리자`];
      this.form.sign2.name = translate[`${prefix}.확인자.관리책임자`];
      const photoList = translate[`${prefix}.교육사진`];
      for (let i = 0; i < photoList.length; i++) {
        photoList[i] = { ...this.form.photoList[i], ...photoList[i] };
      }
      this.$set(this.form, "photoList", photoList);
    },

    /**
     * 문서를 불러왔을 때 사용된다.
     * 문서에는 보안을 위해서, 종사자 ID 값만 보관되어 있다.
     * ID 값에 해당하는 종사자 목록을 불러오도록 한다
     */
    initEmployeeList() {
      if (this.loadEmployee) return;
      // 문서에서 불러온 종사자 정보(id)가 있지만, 종사자 목록이 비어있는 경우
      if (this.form.selectedEmployees && this.form.selectedEmployees.length > 0 && this.employeeList.length === 0) {
        this.loadEmployee = true;
        const page = 1;
        const perPage = this.form.selectedEmployees.length;
        const projectId = this.projectId;
        const ids = this.form.selectedEmployees.map((item) => item.id);

        const payload = { projectId, page, perPage, ids };

        this.$store.dispatch("employee/LOAD_EMPLOYEE_LIST", payload).then((result) => {
          this.loadEmployee = false;
          if (result.data) {
            const _data = result.data;

            // this.form.selectedEmployees 아이템의 id가 일치하는 this.employeeList 아이템에 note 값을 추가한다
            for (const item of this.form.selectedEmployees) {
              const index = _data.findIndex((employee) => employee.id === item.id);
              if (index > -1) {
                _data[index].com_name = _data[index].company.com_name;
                _data[index].note = item.note;
                _data[index].sign = item.sign;
              }
            }

            this.employeeList = JSON.parse(JSON.stringify(_data));
          }
        });
      }
    },

    // education_start_time 시각(10:00:00)으로부터 education_end_time 시각(16:00:00)까지 경과된 시간을 form.educationHours 에 저장한다
    updateEducationHours() {
      if (this.form.education_start_time && this.form.education_end_time) {
        const start = moment(this.form.education_start_time, "HH:mm:ss");
        const end = moment(this.form.education_end_time, "HH:mm:ss");
        const duration = moment.duration(end.diff(start));
        const hours = duration.asHours();

        // 만약 hours 값이 0보다 작다면 0으로 설정한다
        this.form.educationHours = hours < 0 ? 0 : hours;
      }
    },

    // ======================= FORM =======================
    changeTarget1(value) {
      if (!value) return;
      this.form.education_type = value;

      if (1 === this.diff[this.form.education_type.index].child.length) {
        this.form.education_content = this.diff[this.form.education_type.index].child[0].textarea;
      } else {
        this.form.target_work = null;
        this.form.education_content = "";
      }
    },
    changeTarget2() {
      console.log("~~", this.form.education_type, this.form.target_work);
      if (!!this.form.education_type && !!this.form.target_work) this.form.education_content = this.diff[this.form.education_type.index].child[this.form.target_work.index].textarea;
    },
    onClickAddEmployee() {
      this.showPopup = true;
    },
    onClickRemoveEmployee(checkData) {
      // checkData의 배열에 있는 값과 this.employeeList의 id가 같은 것이 제거되도록 this.employeeList를 수정한다
      this.employeeList = this.employeeList.filter((item) => !checkData.includes(item.id));
    },
    handleEmployeeSelect(datas) {
      if (this.employeeList.length > 0) {
        if (datas.length > 0) {
          const adds = datas.filter((v) => {
            for (const emp of this.employeeList) {
              if (emp.id === v.id) {
                return false;
              }
            }
            return true;
          });

          this.employeeList.push(
            ...adds.map((item) => {
              return {
                id: item.id,
                employee_id: item.employee_id,
                com_name: item.com_name ? item.com_name : item.company.com_name,
                field_name: item.field_name ? item.field_name : item.fields.length > 0 ? item.fields[0].field_name : "",
                employment_type: item.employment_type,
                full_name: item.full_name,
              };
            })
          );
        }
      } else {
        this.employeeList = datas.map((item) => {
          return {
            id: item.id,
            employee_id: item.employee_id,
            com_name: item.com_name ? item.com_name : item.company.com_name,
            field_name: item.field_name ? item.field_name : item.fields.length > 0 ? item.fields[0].field_name : "",
            employment_type: item.employment_type,
            full_name: item.full_name,
          };
        });
      }
      const newList = JSON.parse(JSON.stringify(this.employeeList));
      this.employeeList = newList.filter((v, i) => newList.indexOf(v).id === i.id);

      this.form.participants_attended = this.employeeList.length;
    },
  },
};
</script>
